import { signal } from '@preact/signals-react'

const errorMessage = signal<string>('')
const errorStatus = signal<number>(0)
/** Counts the errors, so the same message twice is still seen twice. */
const errorCount = signal<number>(0)

function setError(message: string, status: number) {
    errorMessage.value = message
    errorStatus.value = status
    errorCount.value++
}

function clearError() {
    errorMessage.value = ''
    errorStatus.value = 0
}

function hasError() {
    return errorMessage.value != ''
        && errorStatus.value != 0
}

/**
 * Takes the message out of the store, for a form or dialog that shows it
 * itself. Whatever nobody takes is shown as a notice (ErrorProvider).
 */
function take() {
    const message = errorMessage.value
    clearError()
    return message
}

export default {
    errorMessage,
    errorStatus,
    errorCount,
    setError,
    clearError,
    hasError,
    take,
}
